import { AlertEventsState } from "@idw-types/state/alert-events-state";
import { AppAlertsState } from "@idw-types/state/app-alerts-state";
import { ApplicationState } from "@idw-types/state/application-state";
import { AttributeLabelDetailsState } from "@idw-types/state/attribute-label-details-state";
import { AttributeLabelsState } from "@idw-types/state/attribute-labels-state";
import { CommonReferenceDataState } from "@idw-types/state/common-reference-data-state";
import { DashboardState } from "@idw-types/state/dashboard-state";
import { FraudReportState } from "@idw-types/state/fraud-report-state";
import { IdentityProviderDetailsState } from "@idw-types/state/identity-provider-details-state";
import { IdentityProvidersState } from "@idw-types/state/identity-providers-state";
import { LoadingIndicatorsState } from "@idw-types/state/loading-indicators-state";
import { MessagingTemplateDetailsState } from "@idw-types/state/messaging-template-details-state";
import { MessagingTemplatesState } from "@idw-types/state/messaging-templates-state";
import { OrganizationActivityState } from "@idw-types/state/organization-activity-state";
import { OrganizationInvitationDetailsState } from "@idw-types/state/organization-invitation-details-state";
import { OrganizationInvitationsState } from "@idw-types/state/organization-invitations-state";
import { OrganizationUserDetailsState } from "@idw-types/state/organization-user-details-state";
import { OrganizationUsersState } from "@idw-types/state/organization-users-state";
import { OrganizationsState } from "@idw-types/state/organizations-state";
import { PolicyComponentDetailsState } from "@idw-types/state/policy-component-details";
import { PolicyComponentsState } from "@idw-types/state/policy-components-state";
import { RelyingPartiesState } from "@idw-types/state/relying-parties-state";
import { RelyingPartyDetailsState } from "@idw-types/state/relying-party-details-state";
import { SessionState } from "@idw-types/state/session-state";
import { TableSettingsState } from "@idw-types/state/table-settings-state";
import { UserSummaryState } from "@idw-types/state/user-summary-state";
import { VerificationServiceDetailsState } from "@idw-types/state/verification-service-details-state";
import { VerificationServicesState } from "@idw-types/state/verification-services-state";
import { VerificationTransactionsState } from "@idw-types/state/verification-transactions-state";
import { WorkflowDetailsState } from "@idw-types/state/workflow-details-state";
import { WorkflowReportState } from "@idw-types/state/workflow-report-state";
import { WorkflowUsageDetailsState } from "@idw-types/state/workflow-usage-details-state";
import { WorkflowsState } from "@idw-types/state/workflows-state";

export const getDashboardState = (state: ApplicationState): DashboardState => {
    return state.dashboard;
};

export const getAlertEventsState = (state: ApplicationState): AlertEventsState => {
    return state.alertEvents;
};


export const getCommonReferenceDataState = (state: ApplicationState): CommonReferenceDataState => {
    return state.commonReferenceData;
};

export const getLoadingIndicatorsState = (state: ApplicationState): LoadingIndicatorsState => {
    return state.loadingIndicators;
};

export const getSessionState = (state: ApplicationState): SessionState => {
    return state.session;
};

export const getTableSettingsState = (state: ApplicationState): TableSettingsState => {
    return state.tableSettings;
};

export const getWorkflowsState = (state: ApplicationState): WorkflowsState => {
    return state.workflows;
};

export const getWorkflowDetailsState = (state: ApplicationState): WorkflowDetailsState => {
    return state.workflowDetails;
};

export const getAppAlertsState = (state: ApplicationState): AppAlertsState => {
    return state.appAlerts;
};

export const getIdentityProviderDetailsState = (state: ApplicationState): IdentityProviderDetailsState => {
    return state.identityProviderDetails;
};

export const getIdentityProvidersState = (state: ApplicationState): IdentityProvidersState => {
    return state.identityProviders;
};

export const getVerificationServicesState = (state: ApplicationState): VerificationServicesState => {
    return state.verificationServices;
};

export const getVerificationServiceDetailsState = (state: ApplicationState): VerificationServiceDetailsState => {
    return state.verificationServiceDetails;
};

export const getWorkflowUsageDetailsState = (state: ApplicationState): WorkflowUsageDetailsState => {
    return state.workflowUsageDetails;
};

export const getWorkflowReportState = (state: ApplicationState): WorkflowReportState => {
    return state.workflowReport;
};

export const getVerificationTransactionsState = (state: ApplicationState): VerificationTransactionsState => {
    return state.verificationTransactions;
};

export const getUserSummaryState = (state: ApplicationState): UserSummaryState => {
    return state.userSummary;
};

export const getFraudReportState = (state: ApplicationState): FraudReportState => {
    return state.fraudReport;
};

export const getRelyingPartiesState = (state: ApplicationState): RelyingPartiesState => {
    return state.relyingParties
};

export const getRelyingPartyDetailsState = (state: ApplicationState): RelyingPartyDetailsState => {
    return state.relyingPartyDetails;
};

export const getPolicyComponentsState = (state: ApplicationState): PolicyComponentsState => {
    return state.policyComponents;
};

export const getPolicyComponentDetailsState = (state: ApplicationState): PolicyComponentDetailsState => {
    return state.policyComponentDetails;
};

export const getOrganizationsState = (state: ApplicationState): OrganizationsState => {
    return state.organizations;
};

export const getOrganizationUsersState = (state: ApplicationState): OrganizationUsersState => {
    return state.organizationUsers;
};

export const getOrganizationUserDetailsState = (state: ApplicationState): OrganizationUserDetailsState => {
    return state.organizationUserDetails;
};

export const getOrganizationInvitationsState = (state: ApplicationState): OrganizationInvitationsState => {
    return state.organizationInvitations;
};

export const getOrganizationInvitationDetailsState = (state: ApplicationState): OrganizationInvitationDetailsState => {
    return state.organizationInvitationDetails;
};

export const getMessagingTemplatesState = (state: ApplicationState): MessagingTemplatesState => {
    return state.messagingTemplates;
};

export const getMessagingTemplateDetailsState = (state: ApplicationState): MessagingTemplateDetailsState => {
    return state.messagingTemplateDetails;
};

export const getOrganizationActivityState = (state: ApplicationState): OrganizationActivityState => {
    return state.organizationActivity;
};

export const getAttributeLabelDetailsState = (state: ApplicationState): AttributeLabelDetailsState => {
    return state.attributeLabelDetails;
};

export const getAttributeLabelsState = (state: ApplicationState): AttributeLabelsState => {
    return state.attributeLabels;
};